import { useFetch, useFilter } from "../../../ApiS";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Loader from "../../Loader";
import Search from "../../Search/Search";
import Table from "../../Table";
import Title from "../../Title/Title";

type user = {
  id: number | string;
  created_at: string | number;
};

type Transaction = {
  id: number | string;
  created_at: string | number;
  model_type: string;
  model_id: string;
  user_id: string | number;
};

export default function Dashboard() {

  const { searchParams, handleParamsClick, handleParamDelete } = useFilter();

  const search = searchParams.get("search")

  const { data, isLoading } = useFetch(`admin/logs?search=${search}`, `admin/logs?search=${search}`);

  const Log = data?.data?.data?.map((e: any) => ({
    model_type: e.model_type,
    model_id: e.model_id,
    user_id: e.user.id,
    created_at: e.user.created_at.slice(0, 10),
  }));

  return (
    <>
      <Row>
        <Col>
          <Title title="لوحة المتابعة" />
        </Col>
        <Row>
          <Col lg={11} className="flex justify-center">
            <Search
              placeholder="رقم الحساب "
              className="!w-[80%] border-2 border-[#efc5e6]"
            />
          </Col>
        </Row>
      </Row>
      {isLoading && <Loader/>}
      <Row>
     
          <Table<Transaction>
            tableHeads={[
              "رقم الحساب",
              " وقت البدء",
              " فئة العملية",
              " رقم الحساب الذي تمت عليه العملية",
            ]}
            tableBody={Log}
            keys={[`user_id`, `created_at`, "model_type", "model_id"]}
            className="lg:min-w-[100px] md:min-w-[50px]"
          />
      
      </Row>
    </>
  );
}
